import React, { useState } from "react";
import QRCode from "react-qr-code";
import ContentLoader from "react-content-loader";
import { Button, Input, FormGroup } from "reactstrap";
import NowPaymentsApi from '@nowpaymentsio/nowpayments-api-js'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "../components/Loading";
import 'emoji-picker-element';

const npApi = new NowPaymentsApi({ apiKey: process.env.REACT_APP_NOWPAYMENTS_API_KEY })

/*
  waiting - waiting for the customer to send the payment. The initial status of each payment.
  confirming - the transaction is being processed on the blockchain. Appears when NOWPayments detect the funds from the user on the blockchain.
  confirmed - the process is confirmed by the blockchain. Customer’s funds have accumulated enough confirmations.
  sending - the funds are being sent to your personal wallet. We are in the process of sending the funds to you.
  partially_paid - it shows that the customer sent the less than the actual price. Appears when the funds have arrived in your wallet.
  finished - the funds have reached your personal address and the payment is finished.
  failed - the payment wasn't completed due to the error of some kind.
  refunded - the funds were refunded back to the user.
  expired - the user didn't send the funds to the specified address in the 24 hour time window.
*/
const BUTTON_STATE = {
  'start': 'Donate',
  'select': 'Next',
  'waiting': 'Waiting...',
  'confirming': 'Confirming',
  'confirmed': 'Confirmed',
  'sending': 'Sending',
  'partially_paid': 'Partially Paid',
  'finished': 'Finished',
  'failed': 'Failed',
  'refunded': 'Refunded',
  'expired': 'Expired' 
};

const LINK_ICON = {
  'instagram.com': '/011-instagram.svg',
  'facebook.com': '/001-facebook.svg',
  'twitter.com': '/013-twitter.svg',
  'youtube.com': '/008-youtube.svg',
  'tiktok.com': '/016-tiktok.svg',
  'reddit.com': '/015-reddit.svg'
}

var paymentInterval = null;

export const ProfileComponent = ({user, setUser}) => {
  const [status, setStatus] = useState('start');
  const [showToast, setShowToast] = useState(false);
  const [showLinkForm, setShowLinkForm] = useState(false);
  const [currency, setCurrency] = useState('btc');
  const [amount, setAmount] = useState(20);
  const [paymentData, setPaymentData] = React.useState({});
  const [paymentStatus, setPaymentStatus] = React.useState(null);
  const [links, setLinks] = React.useState(user.links);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [avatar, setAvatar] = useState(user.avatar);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [linkText, setLinkText] = useState('Copy');
  const { getIdTokenClaims, user: auser } = useAuth0();

  React.useEffect(() => {
    document.querySelector('emoji-picker')
      .addEventListener('emoji-click', event => {
        setAvatar(event.detail.unicode);
        setShowEmojiPicker(false);
        saveAvatar(event.detail.unicode);
      });
  }, []);

  function goNext() {
    if(status === 'start') {
      setStatus('select');
    } else if(status === 'select') {
      setStatus('waiting');
      createPayment();
    }
  }

  function goNextDog() {
    if(status === 'start') {
      setStatus('select');
    } else if(status === 'select') {
      setStatus('waiting');
    }
  }

  function copyToClipboard(str, hasToast = true) {
    document.oncopy = function(event) {
      event.clipboardData.setData("Text", str);
      event.preventDefault();
    };
    document.execCommand("Copy");
    document.oncopy = undefined

    if(hasToast) {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 500);
    }
  }

  function handleLinkCopy(str) {
    copyToClipboard(str, false);
    setLinkText('Copied');
    setTimeout(() => setLinkText('Copy'), 1000);
  }

  function getIconLink(link) {
    try {
      return LINK_ICON[(new URL(link.url)).hostname.replace(/^www\./,'')];
    } catch(e) {
      return null;
    }
  }

  async function createPayment() {
    const data = await npApi.createPayment(
      {
        "price_amount": amount < 20 ? 20 : amount,
        "price_currency": "usd",
        "pay_currency": currency,
        "payout_address": user.wallet,
        "payout_currency": 'eth',
        "ipn_callback_url": "https://coindogg.com",
        "order_id": `${user.username}-${Date.now()}`,
        "order_description": `${user.username} - ${currency} - ${amount}usd`
      }
    );
    setPaymentData(data);

    paymentInterval = setInterval(async () => {
      await getPaymentStatus(data.payment_id);
    }, 4000);
  }

  async function getPaymentStatus(payment_id) {
    const data = await npApi.getPaymentStatus({payment_id});
    setPaymentStatus(data.payment_status);
  }

  function deleteLink(e, i) {
    e.preventDefault();
    e.stopPropagation();
    const newLinks = links.filter((x,index) => i !== index);
    setLinks(newLinks);
    saveLinks(newLinks);
  }

  async function saveAvatar(avatar) {
    const token = await getIdTokenClaims();
    const userId = auser.sub.split('|')[1];
    const response = await fetch(`https://lyykjoe06k.execute-api.us-east-1.amazonaws.com/dev/api/user/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token.__raw}`
      },
      body: JSON.stringify({...user, avatar}),
    });
    const data = await response.json();
    setUser(data);
  }

  async function saveLinks(links) {
    const token = await getIdTokenClaims();
    const userId = auser.sub.split('|')[1];
    const response = await fetch(`https://lyykjoe06k.execute-api.us-east-1.amazonaws.com/dev/api/user/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token.__raw}`
      },
      body: JSON.stringify({...user, links}),
    });
    const data = await response.json();
    setUser(data);
  }

  function addLink() {
    if(url.length === 0 && name.length === 0) {
      setShowLinkForm(false);
    } else if(url.length > 0 && name.length > 0) {
      const linkUrl = !url.startsWith('http') ? 'https://' + url : url;
      const newLinks = [...links, {name, url: linkUrl}];
      setLinks(newLinks);
      setName('');
      setUrl('');
      setShowLinkForm(false);
      saveLinks(newLinks);
    }
  }

  function reset() {
    setStatus('start');
    setPaymentStatus(null);
    clearInterval(paymentInterval);
  }

  if(
    paymentStatus === 'finished' || 
    paymentStatus === 'failed' || 
    paymentStatus === 'refunded' || 
    paymentStatus === 'expired' || 
    paymentStatus === 'partially_paid'
  ) {
    clearInterval(paymentInterval);
  }

  return (
    <>
      <div className="frame">
        <div style={{position:'relative'}}>
          <span className="avatar" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>{avatar}</span>
          <FontAwesomeIcon icon="pen-square" />
          <emoji-picker style={{display: showEmojiPicker ? 'block' : 'none'}}></emoji-picker>
        </div>
        <div className="info">
          <h4 style={{cursor: 'pointer'}} onClick={reset}>{user.name ? user.name : ''}</h4>
          <h6 style={{cursor: 'pointer'}} onClick={reset}>{user.username ? '@' + user.username : ''}</h6>
        </div>
        { status === 'select' &&
          <div style={{marginTop: '10px', color: '#333333' }}>
            <div><label>Select Currency</label></div>
            <select className="select-currency" size="7" style={{width: '100%', borderColor: '#ced4da'}} onChange={e => setCurrency(e.target.value)}> 
              <option key="btc" value="btc" style={{backgroundImage:"url('/btc.svg')"}}>Bitcoin (BTC)</option>
              <option key="bch" value="bch" style={{backgroundImage:"url('/bch.svg')"}}>Bitcoin Cash (BCH)</option>
              <option key="dog" value="dog" style={{backgroundImage:"url('/dog-80x80.png')"}}>CoinDogg (DOG)</option>
              <option key="dash" value="dash" style={{backgroundImage:"url('/dash.svg')"}}>Dash (DASH)</option>
              <option key="dgb" value="dgb" style={{backgroundImage:"url('/dgb.svg')"}}>DigiByte (DGB)</option>
              <option key="doge" value="doge" style={{backgroundImage:"url('/doge.svg')"}}>Dogecoin (DOGE)</option>
              <option key="eth" value="eth" style={{backgroundImage:"url('/eth.svg')"}}>Ethereum (ETH)</option>
              <option key="ltc" value="ltc" style={{backgroundImage:"url('/ltc.svg')"}}>Litecoin (LTC)</option>
              <option key="xmr" value="xmr" style={{backgroundImage:"url('/xmr.svg')"}}>Monero (XMR)</option>
              <option key="trx" value="trx" style={{backgroundImage:"url('/trx.svg')"}}>Tron (TRX)</option>
              <option key="usdterc20" value="usdterc20" style={{backgroundImage:"url('/usdterc20.svg')"}}>USDT (USDT-ERC20)</option>
              <option key="XRP" value="XRP" style={{backgroundImage:"url('/xrp.svg')"}}>XRP (XRP)</option>
            </select>
            <div style={{marginTop: '10px'}}><label>Enter Amount </label></div>
            <Input placeholder="$USD 20.00" type="number" onChange={e => setAmount(e.target.value)} />
          </div>
        }
        { status === 'waiting' && !paymentData.price_amount && currency !== 'dog' &&
          <>
            <br />
            <ContentLoader 
              speed={2}
              width={360}
              height={160}
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
              style={{maxWidth: '100%'}}
            >
              <rect x="0" y="0" rx="2" ry="2" width="160" height="18" />
              <rect x="0" y="24" rx="2" ry="2" width="360" height="18" />
              <rect x="0" y="72" rx="2" ry="2" width="160" height="18" />
              <rect x="0" y="96" rx="2" ry="2" width="360" height="18" />
            </ContentLoader>
            <div style={{textAlign:'center'}}>
              <ContentLoader 
                speed={2}
                width={160}
                height={190}
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="0" rx="2" ry="2" width="160" height="160" />
              </ContentLoader>
            </div>
          </>
        }
        { status === 'waiting' && currency !== 'dog' && paymentData.price_amount && paymentData.pay_address != null &&
          <>
            <div>
              <br />
              <div>Send <span style={{textTransform: 'uppercase'}}>{paymentData.pay_currency}</span></div>
              <div><b>${paymentData.price_amount.toFixed(2)} ({paymentData.pay_amount} <span style={{textTransform: 'uppercase'}}>{paymentData.pay_currency}</span>)</b></div>
              <br />
              <div>To <span style={{textTransform: 'uppercase'}}>{paymentData.pay_currency}</span> Address</div>
              <div className="address">
                <b style={{wordBreak: 'break-word'}} onClick={() => copyToClipboard(paymentData.pay_address)}>{paymentData.pay_address}</b>
                &nbsp;
                <img src="/icon-copy.png" alt="" height="18" onClick={() => copyToClipboard(paymentData.pay_address)} />
                <span className={showToast ? 'copied active' : 'copied'}>Copied</span>
              </div>
            </div>
            <div className={`progress-bar ${paymentStatus}`}>
              <div className="box" onClick={() => copyToClipboard(paymentData.pay_address)}>
                <QRCode value={paymentData.pay_address} size={128} />
              </div>
            </div>
          </>
        }
        { status === 'waiting' && currency === 'dog' &&
          <>
            <div>
              <br />
              <div>Send <span style={{textTransform: 'uppercase'}}>DOG</span></div>
              <div><b>${Number(amount).toFixed(2)}</b></div>
              <br />
              <div>To <span style={{textTransform: 'uppercase'}}>DOG</span> Address</div>
              <div className="address">
                <b style={{wordBreak: 'break-word'}} onClick={() => copyToClipboard(user.wallet)}>{user.wallet}</b>
                &nbsp;
                <img src="/icon-copy.png" alt="" height="18" onClick={() => copyToClipboard(user.wallet)} />
                <span className={showToast ? 'copied active' : 'copied'}>Copied</span>
              </div>
            </div>
            <div className={`progress-bar`}>
              <div className="box" onClick={() => copyToClipboard(paymentData.pay_address)}>
                <QRCode value={user.wallet} size={128} />
              </div>
            </div>
          </>
        }
        { currency !== 'dog' &&
          <Button className="donate-btn btn-primary" disabled={status === 'waiting' || user.wallet == '' && status === 'select'} onClick={goNext}>{BUTTON_STATE[paymentStatus ? paymentStatus : status]}</Button>
        }
        { currency === 'dog' &&
          <Button className="donate-btn btn-primary" disabled={status === 'waiting' || user.wallet == '' && status === 'select'} onClick={goNextDog}>{BUTTON_STATE[status]}</Button>
        }
        { status === 'start' &&
          <div className="links">
            {links.map((link, i) => (
              <a href={link.url} key={link.url + i} title={link.url} target="_blank">
                {getIconLink(link) && <img src={getIconLink(link)} alt="" width="30" />}
                <div>{link.name}</div>
                <span onClick={e => deleteLink(e, i)}><FontAwesomeIcon icon="times" /></span>
              </a>
            ))}
            { !showLinkForm && 
              <a style={{border: '1px dashed', background: 'none', cursor: 'pointer'}} onClick={() => setShowLinkForm(true)}>
                <FontAwesomeIcon icon="plus" />
                <div>Add Link</div>
              </a>
            }
            { showLinkForm && 
              <div style={{marginTop: '1rem'}}>
                <FormGroup>
                  <Input type="text" name="title" id="title" placeholder="Name" onChange={e => setName(e.target.value)} />
                </FormGroup>
                <FormGroup>
                  <Input type="text" name="url" id="url" placeholder="URL" onChange={e => setUrl(e.target.value)} />
                </FormGroup>
                <Button onClick={addLink} className="btn-primary" style={{borderRadius: '10px'}}>Add Link</Button>
              </div>
            }
          </div>
        }
      </div>
      <div className="share-link">
        <a href={'https://coindo.gg/' + user.username} target="_blank">https://coindo.gg/{user.username}</a>
        <Button className="ripple" onClick={() => handleLinkCopy('https://coindo.gg/' + user.username)}>{linkText}</Button>
      </div>
    </>  
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
